app.service('systemService', function ($http, $location, safeApply) {

  this.functionCall = function (obj) {
    return $http.post(`/system/server/functionCall`, obj)
      .then(function (response) {
        return response
      })
  }


})